module.exports = __webpack_public_path__ + "static/media/f_eyeshape_almond_hazel.2b87de40.png";